import React, { Component, Fragment } from 'react';
import { Field } from 'redux-form';
import { Grid, Button, Header } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { SelectField } from 'Common/SemanticWrapper';
import { MappingModalField } from 'Common/ReduxFormFields/MappingModalField';

import 'Styles/components/sisfields.less';

export default class SISFields extends Component {
  static propTypes = {
    integrationMapOptions: PropTypes.array.isRequired,
    integrationMapConfig: PropTypes.object.isRequired,
    integrationMapData: PropTypes.object.isRequired,
    integrationSourceOptions: PropTypes.object,
  };

  openMappingModal = childMap => {
    this.setState({
      mappingModalProps: {
        name: childMap.key,
        title: childMap.name,
        doneCallback: () => {
          this.setState({ mappingModalProps: null });
        },
        mappingOptions: this.props.integrationMapData[childMap.key],
        sourceOptions: get(this.props.integrationSourceOptions, childMap.key),
      },
    });
  };

  state = {
    mappingModalProps: null,
  };

  render() {
    const { integrationMapOptions, integrationMapConfig, loading } = this.props;
    const { mappingModalProps } = this.state;

    return (
      <Grid>
        {integrationMapOptions.map(field => {
          const options = integrationMapConfig[field.key].options;
          const childMap = get(integrationMapConfig[field.key], 'childMap');
          const other = get(integrationMapConfig[field.key], 'props');

          return (
            <Fragment key={field.key}>
              <Grid.Column width={3}>
                <Header as="h5" textAlign="center" block>
                  {field.value}
                </Header>
              </Grid.Column>
              <Grid.Column width={5} stretched>
                <Field
                  className={'SISField-select-field'}
                  name={field.key}
                  component={SelectField}
                  disabled={loading}
                  options={options}
                  {...other}
                />
                {childMap ? (
                  <Button
                    compact
                    onClick={() => {
                      this.openMappingModal(childMap);
                    }}
                  >
                    {childMap.name}
                  </Button>
                ) : (
                  undefined
                )}
              </Grid.Column>
            </Fragment>
          );
        })}
        {mappingModalProps && (
          <Field component={MappingModalField} {...mappingModalProps} />
        )}
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/SISFields.js